import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Calendar as CalendarComponent } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { VIEWING_OTHER_RESOURCE_TITLE } from './weekNavTypes';

export interface WeekNavCalendarPopoverProps {
  currentWeekStart: Date;
  minAllowedDate: Date;
  maxAllowedDate: Date | undefined;
  isViewingOtherResource: boolean;
  onNavigateToDate: (date: Date) => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/** Date picker popover shared by the desktop, tablet and mobile week selectors. */
export function WeekNavCalendarPopover({
  currentWeekStart,
  minAllowedDate,
  maxAllowedDate,
  isViewingOtherResource,
  onNavigateToDate,
  open,
  onOpenChange,
}: WeekNavCalendarPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          aria-label="Pick a date"
          disabled={isViewingOtherResource}
          title={isViewingOtherResource ? VIEWING_OTHER_RESOURCE_TITLE : undefined}
        >
          <Calendar className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <CalendarComponent
          mode="single"
          selected={currentWeekStart}
          onSelect={(date) => {
            if (date) onNavigateToDate(date);
          }}
          disabled={(date) => {
            if (date < minAllowedDate) return true;
            if (maxAllowedDate && date > maxAllowedDate) return true;
            return false;
          }}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  );
}
